import cs from "assets/locales/cs.json" with { type: "json" };
import en from "assets/locales/en-gb.json" with { type: "json" };
import { use } from "i18next";
import { initReactI18next } from "react-i18next";

export const defaultNS = "translation";

use(initReactI18next).init({
	lng: "cs", // if you're using a language detector, do not define the lng option
	fallbackLng: "cs",
	debug: import.meta.env.DEV,
	defaultNS: defaultNS,
	resources: {
		cs: {
			translation: cs,
		},
		en: {
			translation: en,
		},
	},

	// if you see an error like: "Argument of type 'DefaultTFuncReturn'
	// is not assignable to parameter of type xyz"
	// set returnNull to false (and also in the i18next.d.ts options)
	// returnNull: false,
});
